<template>
  <div>
    <template v-if="!discountCard.isCreated">
      <div class="discount-card__group">
        <div class="discount-card__group__title">{{ discountCard.typeName }}</div>
        <div class="discount-card__group__value">
          <button
            class="discount-card__create-bonus-card"
            type="button"
            v-on:click="onCreateDiscountCardModal"
          >Выпустить
          </button>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="discount-card__group">
        <div class="discount-card__group__title">{{ cardTitle }}</div>
        <div class="discount-card__group__value">
          <p>Процент: {{ discountCard.level.getDiscountPercent() }} %</p>
          <the-tooltip position="bottom">
            <template v-slot:trigger="{ listenerObject }">
              <span v-on="listenerObject">
                <button
                  class="discount-card__button advance-details-open"
                  type="button"
                  v-on:click="openDetailDiscountCardSidebar"
                >Детализация Скидочной карты</button>
              </span>
            </template>
            {{ cardTitle }}
          </the-tooltip>
        </div>
      </div>
    </template>
  </div>

</template>

<script>
import { CARD_TYPE_DISCOUNT, DiscountCard } from '@/mixins/loyaltySystemMixin';
import TheTooltip from '@/components/TheTooltip.vue';

/**
 * @description Наименование события создания скидочной карты
 * @type {string}
 */
const NAME_EVENT_CREATE_DISCOUNT_CARD = 'create-discount-card';
/**
 * @description Наименование события открытия детализации бонусной карты
 * @type {string}
 */
const NAME_EVENT_OPEN_DETAILS_DISCOUNT_CARD = 'open-details-discount-card';

export default {
  /**
   * @description Скидочная карта пациента
   */
  name: 'DiscountCard',
  components: {
    TheTooltip,
  },
  computed: {
    /**
     * @description Заголовок карты
     * @returns {string}
     */
    cardTitle() {
      return `${this.discountCard.typeName} № ${this.discountCard.number}`;
    },
  },
  props: {
    /**
     * @description Скидочная карта
     * @type DiscountCard
     */
    discountCard: {
      type: DiscountCard,
      required: true,
    },
  },
  CARD_TYPE_DISCOUNT,
  methods: {
    /**
     * @description Обработать событие создания скидочной карты
     * @returns {void}
     */
    onCreateDiscountCardModal() {
      this.$emit(NAME_EVENT_CREATE_DISCOUNT_CARD);
    },
    /**
     * @description Отрыть детализацию скидочной карты
     * @returns {void}
     */
    openDetailDiscountCardSidebar() {
      this.$emit(NAME_EVENT_OPEN_DETAILS_DISCOUNT_CARD);
    },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";

.discount-card {
  align-items: center;
  background-color: var(--section-background-color);
  display: flex;
  flex-direction: row;
  gap: 20px 1rem;
  padding: 20px;

  &__group {
    display: flex;
    flex-direction: column;
    gap: 5px;

    &__title {
      color: #90A0B7;
      font-size: 14px;
      line-height: 17px;
    }

    &__value {
      color: #192A3E;
      display: flex;
      flex-direction: row;
      font-weight: 800;
      font-size: 18px;
      gap: .5rem;
      line-height: 21px;
    }
  }

  &__create-bonus-card {
    font-weight: 400;
    color: var(--action-color);
    transition: color 0.3s ease;
    &:hover {
      color: #0076C3;
    }
  }

  &__button {
    display: block;
    position: relative;
    border: 1px solid var(--action-color);
    border-radius: 4px;
    font-size: 0;
    height: 1.5rem;
    width: 1.5rem;

    &.recharge {
      background: no-repeat center url("@/assets/img/plus.svg");
    }

    &.withdrawal {
      background: no-repeat center url("@/assets/img/minus-rounded-blue.svg");
    }

    &.advance-details-open {
      background: no-repeat center url("@/assets/img/trending-up.svg");
    }
  }
}

@media screen and (max-width: 700px) {
  .discount-card__button {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
